import debug from '../utils/console'
import { OpenFeature } from '@openfeature/web-sdk'
const logger = debug.extend('openfeature')

export default defineNuxtPlugin({
  name: 'openfeature',
  setup: async (nuxtApp) => {
    const uuid = () => {
      // generate a cheap UUID v4 without crypto
      // (for environments that don't support it, which should be rare)
      // @see https://developer.mozilla.org/en-US/docs/Web/Security/Secure_Contexts
      const random = () => Math.floor(Math.random() * 16).toString(16)
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'
        .replace(/[xy]/g, (c) => {
          const r = random()
          const v = c === 'x' ? r : (parseInt(r, 16) & 0x3) | 0x8
          return v.toString(16)
        })
        .toUpperCase()
    }

    const targetingKey = useCookie('targetingKey')
    targetingKey.value = targetingKey.value || crypto?.randomUUID() || uuid()
    OpenFeature.setContext({
      ...OpenFeature.getContext(),
      targetingKey: targetingKey.value,
    })
    const {
      registerMultipleFeatureFlagProviders,
      registerFeatureFlagProvider,
    } = await import('../openfeature/client')
    const { configCatSdkKey } = useRuntimeConfig().public
    const {
      openfeature = {
        multiProvider: false,
        localProvider: false,
        queryProvider: false,
      },
    } = useAppConfig()
    const {
      multiProvider = false,
      localProvider = false,
      queryProvider = false,
    } = openfeature

    const options = {
      configCatKey: configCatSdkKey ?? undefined,
      localProvider,
      queryProvider,
    }
    const client = multiProvider
      ? await registerMultipleFeatureFlagProviders(options)
      : await registerFeatureFlagProvider(options)

    logger.log({ client, OpenFeature, context: OpenFeature.getContext() })
    nuxtApp.provide('openfeature', client)
  },
})
